import { render, staticRenderFns } from "./SceneTreePanel.vue?vue&type=template&id=aadc7604&scoped=true"
import script from "./SceneTreePanel.vue?vue&type=script&lang=js"
export * from "./SceneTreePanel.vue?vue&type=script&lang=js"
import style0 from "./SceneTreePanel.vue?vue&type=style&index=0&id=aadc7604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadc7604",
  null
  
)

export default component.exports